import Sentry from 'Integrations/Sentry';
import GenericError from 'Errors/GenericError';
import EventTrackingEvent from './EventTrackingEvent';

export const dispatchEvent = (eventDetail) => {
  document.dispatchEvent(new EventTrackingEvent(eventDetail));
};

const applyFilter = dispatcherFilterObj => (vendorFilterObj) => {
  if (typeof vendorFilterObj !== 'object') {
    throw new GenericError('invalid-event-tracking-dispatcher-filter', `Expected filter to be an object but was ${typeof value} instead.`);
  }

  const keys = Object.keys(dispatcherFilterObj);

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const filter = dispatcherFilterObj[key];

    // If the key is a function, then pass the value into the function and let that be what is evaluated
    if (typeof filter === 'function') {
      if (!filter(vendorFilterObj)) {
        return false;
      }
    // Else just match the value of the field to the value of the filter obj
    } else if (vendorFilterObj[key] !== dispatcherFilterObj[key]) {
      return false;
    }
  }

  return true;
};

class Dispatcher {
  constructor() {
    this._listeners = [];

    document.addEventListener(EventTrackingEvent.eventName, ({ detail }) => {
      const { type, properties } = detail;

      const dispatcherCriteria = {
        type,
        isDisabled: (obj) => {
          return obj.isDisabled !== true;
        },
      };

      const filterFn = applyFilter(dispatcherCriteria);

      this._listeners.filter((listener) => {
        const { filter: venderFilterObj } = listener;
        return filterFn(venderFilterObj);
      }).forEach(({ action }) => {
        try {
          action(properties);
        } catch (err) {
          Sentry.createSentryErrorLog(err);
        }
      });
    });
  }

  static init() {
    dispatchEvent({ type: 'init' });
  }

  _register(filter, action) {
    this._listeners = [...this._listeners, { filter, action }];
  }

  registerInit(filter, action) {
    this._register({ ...filter, type: 'init' }, action);
  }

  registerIdentify(filter, action) {
    this._register({ ...filter, type: 'identify' }, action);
  }

  registerLogPage(filter, action) {
    this._register({ ...filter, type: 'page' }, action);
  }

  registerLogEvent(filter, action) {
    this._register({ ...filter, type: 'logEvent' }, action);
  }
}

export default new Dispatcher();
